import { render, staticRenderFns } from "./ReturnServicesComponent.vue?vue&type=template&id=7405d3a3"
import script from "./ReturnServicesComponent.vue?vue&type=script&lang=js"
export * from "./ReturnServicesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports